
  import {Component, Vue} from "vue-property-decorator";
  import CorpsTable from "@/modules/Corps/components/CorpsTable.vue";
  import CorpsFilter from "@/modules/Corps/components/CorpsFilter.vue";

  @Component({
    components: {
      CorpsFilter,
      CorpsTable,
    }
  })
  export default class CorpsIntro extends Vue {


  }
